import cn from 'classnames'
import type { PropsWithChildren } from 'react'

import * as s from './TableLayout.module.scss'

interface ITableLayoutProps {
  free?: boolean
}

const TableLayout: React.FC<PropsWithChildren<ITableLayoutProps>> = ({ children, free }) => {
  return <div className={cn(s.root, { [s.free]: free })}>{children}</div>
}

export default TableLayout
